export const LEGALPEIL_LOADING = "LEGALPEIL_LOADING";
export const LEGALPEIL_RESET = "LEGALPEIL_RESET";
export const GET_LEGALPEIL = "GET_LEGALPEIL";
export const GET_LEGALPEIL_SUCCESS = "GET_LEGALPEIL_SUCCESS";
export const GET_LEGALPEIL_FAIL = "GET_LEGALPEIL_FAIL";
export const DELETE_LEGALPEIL = "DELETE_LEGALPEIL"
export const DELETE_LEGALPEIL_SUCCESS = "DELETE_LEGALPEIL_SUCCESS"
export const DELETE_LEGALPEIL_FAIL = "DELETE_LEGALPEIL_FAIL"
export const UPDATE_LEGALPEIL = "UPDATE_LEGALPEIL"
export const UPDATE_LEGALPEIL_SUCCESS = "UPDATE_LEGALPEIL_SUCCESS"
export const UPDATE_LEGALPEIL_FAIL = "UPDATE_LEGALPEIL_FAIL"
export const ADD_NEW_LEGALPEIL = "ADD_NEW_LEGALPEIL"
export const ADD_LEGALPEIL_SUCCESS = "ADD_LEGALPEIL_SUCCESS"
export const ADD_LEGALPEIL_FAIL = "ADD_LEGALPEIL_FAIL"